import React, { useMemo, useEffect } from 'react';
import { Route, Router } from 'react-router-dom';

// Pages
import WebinarRegistrationPage from './pages/WebinarRegistrationPage';
import WebinarConfirmationPage from './pages/WebinarConfirmationPage';
import WebinarJoinPage from './pages/WebinarJoinPage';
import WebinarWatchPage from './pages/WebinarWatchPage';
import WebinarRatingPage from './pages/WebinarRatingPage';

// Styles
import 'shared/styles/shared.scss';
import './styles/style.scss';

// Utils
import createHistory from 'utils/createHistory';
import BravelyData from 'utils/data';

// Helpers
import { mixpanelIdentify } from 'utils/mixpanelHelpers';
import { basePath } from 'employee-pro-shared/constants';

// Context
import WebinarsContext from './context';

const WebinarsApp = ({ webinar }) => {
  const history = useMemo(() => createHistory('/'), []);
  const currentUser = BravelyData('user');

  useEffect(() => {
    currentUser && mixpanelIdentify(currentUser.encoded_id);
  }, []);

  return (
    <WebinarsContext.Provider value={{ webinar }}>
      <Router history={history}>
        <Route exact path={`${basePath}/webinars/:id`}>
          <WebinarRegistrationPage />
        </Route>
        <Route path={`${basePath}/webinars/:id/watch`}>
          <WebinarWatchPage />
        </Route>
        <Route path="/webinars/:id/confirmation">
          <WebinarConfirmationPage />
        </Route>

        {BravelyData('useZoomSdk') && (
          <Route path="/webinars/:id/join">
            <WebinarJoinPage />
          </Route>
        )}

        <Route path="/webinars/:id/rating">
          <WebinarRatingPage />
        </Route>
      </Router>
    </WebinarsContext.Provider>
  );
};

export default WebinarsApp;
